export default __webpack_public_path__ + "static/media/loader.eeea6e91.gif";